import GameObject from '../../../GameObject/GameObject';
import AnimationClip from '../AnimationClip';
import { Easing, Tween } from '@tweenjs/tween.js';
import ElementComponent from '../../../Component/UI/Element';

export class PostcardIntro extends AnimationClip {
    public *execute(gameObject: GameObject): IterableIterator<number> {
        const element = gameObject.getComponent(ElementComponent);
        const tween: Tween = this.getTween(element);
        tween
            .to({ offsetY1: 0, offsetY2: 0, rotation: -0.05 }, 700)
            .easing(Easing.Quadratic.Out);

        yield* this.startTween(tween);
    }
}
